import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import { formatDate } from "@/helpers/date";
  import { getLotStatusClass } from "@/helpers/status";
  import { LotInterface } from "@/types/LotInterface";
  import { LotActionInterface } from "@/types/LotActionInterface";
  import { LotStatus } from "@/enums/LotStatus";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardActivity',
  props: {
    actions: {
      type: Array,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const getChangedActions = computed(() => {
    return props.actions.filter(
      (value) =>
        (value as LotActionInterface).action === "changed" &&
        filterActions((value as LotActionInterface).changedParams).length
    );
  });

  function filterActions(fields: Array<keyof LotInterface>) {
    const allowedFields: Array<keyof LotInterface> = ["status", "applicants"];

    return fields.filter((value) => allowedFields.includes(value));
  }

  function getDisplayStatusClass(status: LotStatus) {
    return getLotStatusClass(
      status === LotStatus.EOI ? LotStatus.PRE_CONTRACT : status
    );
  }

const __returned__ = { props, getChangedActions, filterActions, getDisplayStatusClass, computed, get formatDate() { return formatDate }, get getLotStatusClass() { return getLotStatusClass }, get LotInterface() { return LotInterface }, get LotActionInterface() { return LotActionInterface }, get LotStatus() { return LotStatus } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})